"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.offerTypeSelectorOptions = exports.EOfferType = void 0;
/**
 * Взято из lead-realtor-form /v1/get-form
 * question: offerType
 * @see question.answers
 * */
let EOfferType = exports.EOfferType = /*#__PURE__*/function (EOfferType) {
  EOfferType["Flat"] = "flat";
  EOfferType["Suburban"] = "suburban";
  EOfferType["Commercial"] = "commercial";
  return EOfferType;
}({});
const offerTypeSelectorOptions = exports.offerTypeSelectorOptions = [{
  value: EOfferType.Flat,
  selectedLabel: 'Жилая',
  label: 'Жилая'
}, {
  value: EOfferType.Suburban,
  selectedLabel: 'Загородная',
  label: 'Загородная'
}, {
  value: EOfferType.Commercial,
  selectedLabel: 'Коммерческая',
  label: 'Коммерческая'
}];